export const NEXT_LOCALE = "NEXT_LOCALE";
